import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for UA students with study abroad deadlines",
      "Perfect for MBUSI engineers flying to Stuttgart",
      "Great for Northport families with upcoming travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Tuscaloosa post offices",
      "Good for planned international trips from West Alabama",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Tuscaloosa or Northport USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — ~200 mi, 3.5+ hrs drive",
      "NPIC appointment required before traveling to Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day at Atlanta agency",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function TuscaloosaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Tuscaloosa"
      introText="Tuscaloosa travelers — University of Alabama students studying abroad in Barcelona and London, Mercedes-Benz US International engineers flying to Stuttgart, Stillman College students doing international exchanges, and Northport families heading to Cancun — have several options for getting a passport fast. Here is how they compare, and why most West Alabama residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 200-mile drive to Atlanta."
      options={options}
      emergencyDescription="Tuscaloosa does not have its own regional passport agency. The closest is Atlanta — about 200 miles east, a 3.5+ hour drive through Birmingham on I-20. For a UA student with a study abroad flight in 5 days or an MBUSI engineer with a product launch in Stuttgart next week, that round trip is brutal. I-20 construction between Birmingham and Atlanta adds unpredictable delays, and during football season, gameday traffic compounds the problem."
      disclaimerText="*Processing speed depends on eligibility and documentation. Tuscaloosa does not have a regional passport agency — the closest is Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}